// Assign states to each region and set the appropriate data-region attribute
function assignStates(region) {
    console.log(region.states);
    const states = region.states.replace(/ /g, '').split(',');
    console.log(states);
  
    states.forEach((state) => {
      const statePath = document.getElementById(state);
      if (statePath) {
        statePath.setAttribute('data-region', region.name);
      }
    });
  }
  
  // Activate the paths and info sections for a given region
  function activateStates(element) {
    const reg_sel = element.getAttribute('data-region');
  
    // Remove active classes from all paths and region info sections
    document.querySelectorAll('#us-map path').forEach((path) => {
      path.classList.remove('active');
    });
    document.querySelectorAll('.MapWidget .info__region').forEach((infoRegion) => {
      infoRegion.classList.remove('info__region--active');
    });
  
    // Add active class to all paths with the same data-region
    document.querySelectorAll(`#us-map path[data-region="${reg_sel}"]`).forEach((path) => {
      path.classList.add('active');
    });
    // Add active class to the corresponding info region
    document
      .querySelectorAll(`.MapWidget .info__region[data-region="${reg_sel}"]`)
      .forEach((infoRegion) => {
        infoRegion.classList.add('info__region--active');
      });
  
    // Update title text
    const mapTitle = document.querySelector('.MapWidget .map_title');
    if (mapTitle) {
      mapTitle.textContent = `${reg_sel}`;
    }
  }
  
  // Main function to initialize the map
  function makeMap() {
    // Grab the data-regions attribute from .MapWidget
    const mapWidget = document.querySelector('.MapWidget');
    const regionsData = mapWidget?.getAttribute('data-regions');
    if (!regionsData) return null;
  
    const regions = JSON.parse(regionsData);
  
    // Assign states to each region
    regions.forEach((region) => assignStates(region));
  
    // Listen for mouseover and touchstart on the #us-map container;
    // if the target is a <path>, call activateStates.
    ['mouseover', 'touchstart'].forEach((eventType) => {
      document.getElementById('us-map').addEventListener(eventType, (e) => {
        if (e.target && e.target.matches('path')) {
          activateStates(e.target);
        }
      });
    });
  
    // Optional: Activate a default region if desired
    /*
    const defaultRegionElement = document.querySelector('.MapWidget .info__region');
    if (defaultRegionElement) {
      const def_reg = defaultRegionElement.getAttribute('data-region');
      const defaultPath = document.querySelector(`#us-map path[data-region="${def_reg}"]`);
      if (defaultPath) {
        activateStates(defaultPath);
      }
    }
    */
  
    return null;
  }
  
  export default makeMap;
  